var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import service from "@irati/reporting/services/reporting";
import authentication from "@irati/auth";
import { ReportingPeriodGranularity, ReportingSegmentOption } from "@irati/types";
import { hangPromise } from "@irati/utils/promise";
import { H3, H4 } from "@irati/ui/src/Headings";
import { Card } from "@irati/ui/src/Layout";
import { DateRangeWrapper, TopPerks, SparkLane, ExploreMore } from "../../components/ReportingV3";
import { PerkRedemptionsChart, PlatformActivityChart } from "../../components/ReportingV3/Chart";
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            tenantId: authentication.userTenant().uuid,
            perkRedemptionsSummary: { redeemed: 0, brands: 0, sparkData: { info: { label: "" }, points: [] } },
            activeUsersSummary: { perkbox: 0, app: 0, sparkData: { info: { label: "" }, points: [] } },
            perksGOTransactionsSummary: { transactions: 0, savings: 0, sparkData: { info: { label: "" }, points: [] } },
            perkRedemptions: {
                properties: { label: "" },
                series: []
            },
            platformActivity: {
                properties: { label: "" },
                series: []
            },
            mostPopularPerks: { perks: [] },
            loadingSparkData: hangPromise()
        };
        return _this;
    }
    Home.prototype.fetchSparkData = function (startDate, endDate) {
        var _this = this;
        var tenantId = this.state.tenantId;
        var promises = [
            service.getActiveUsersSummary({ tenantId: tenantId, startDate: startDate, endDate: endDate, granularity: ReportingPeriodGranularity.M }),
            service.getPerkRedemptionsSummary({ tenantId: tenantId, startDate: startDate, endDate: endDate, granularity: ReportingPeriodGranularity.M }),
            service.getPerksGOTransactionsSummary({
                tenantId: tenantId,
                startDate: startDate,
                endDate: endDate,
                granularity: ReportingPeriodGranularity.M
            })
        ];
        var sparkDataLoadingState = Promise.all(promises).then(function (results) {
            var activeUsersSummary = results[0], perkRedemptionsSummary = results[1], perksGOTransactionsSummary = results[2];
            _this.setState({ activeUsersSummary: activeUsersSummary, perkRedemptionsSummary: perkRedemptionsSummary, perksGOTransactionsSummary: perksGOTransactionsSummary });
        });
        this.setState({ loadingSparkData: sparkDataLoadingState });
    };
    Home.prototype.fetchRedemptionsData = function (startDate, endDate) {
        var _this = this;
        var tenantId = this.state.tenantId;
        service
            .getPerkRedemptions({
            tenantId: tenantId,
            startDate: startDate,
            endDate: endDate,
            granularity: ReportingPeriodGranularity.D,
            segment: ReportingSegmentOption.PerkCategory,
            filters: []
        })
            .then(function (perkRedemptions) {
            _this.setState({ perkRedemptions: perkRedemptions });
        });
    };
    Home.prototype.fetchActivityData = function (startDate, endDate) {
        var _this = this;
        var tenantId = this.state.tenantId;
        service
            .getPlatformActivity({
            tenantId: tenantId,
            startDate: startDate,
            endDate: endDate,
            granularity: ReportingPeriodGranularity.D,
            segment: ReportingSegmentOption.PerkCategory,
            filters: []
        })
            .then(function (platformActivity) {
            _this.setState({ platformActivity: platformActivity });
        });
    };
    Home.prototype.fetchPopularPerks = function (startDate, endDate) {
        var _this = this;
        var tenantId = this.state.tenantId;
        service
            .getMostPopularPerks({
            tenantId: tenantId,
            startDate: startDate,
            endDate: endDate,
            granularity: ReportingPeriodGranularity.D,
            segment: ReportingSegmentOption.PerkUuid,
            filters: []
        })
            .then(function (mostPopularPerks) {
            _this.setState({ mostPopularPerks: mostPopularPerks });
        });
    };
    Home.prototype.render = function () {
        var _a = this.state, activeUsersSummary = _a.activeUsersSummary, perkRedemptionsSummary = _a.perkRedemptionsSummary, perksGOTransactionsSummary = _a.perksGOTransactionsSummary, perkRedemptions = _a.perkRedemptions, platformActivity = _a.platformActivity, mostPopularPerks = _a.mostPopularPerks, loadingSparkData = _a.loadingSparkData;
        var _b = perkRedemptions.series, series = _b === void 0 ? undefined : _b;
        var _c = platformActivity.series, activitySeries = _c === void 0 ? undefined : _c;
        var tenantPublicName = authentication.userTenant().public_name;
        var popularPerks = mostPopularPerks.perks;
        return (React.createElement(React.Fragment, null,
            React.createElement(H3, { small: true },
                React.createElement(FormattedMessage, { id: "admin.reportingV3.home.title" })),
            React.createElement(H4, null,
                React.createElement(FormattedMessage, { id: "admin.reportingV3.home.subTitle" }),
                " ",
                React.createElement("strong", null, tenantPublicName)),
            React.createElement(DateRangeWrapper, { fetch: this.fetchSparkData.bind(this) },
                React.createElement(SparkLane, { loading: loadingSparkData, activeUsersSummary: activeUsersSummary, perkRedemptionsSummary: perkRedemptionsSummary, perksGOTransactionsSummary: perksGOTransactionsSummary })),
            React.createElement(Card, null,
                React.createElement(DateRangeWrapper, { fetch: this.fetchRedemptionsData.bind(this) },
                    React.createElement(PerkRedemptionsChart, { data: series }),
                    React.createElement(ExploreMore, { adminPath: "/reporting-v3/redemptions" }))),
            React.createElement("br", null),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: 6 },
                    React.createElement(Card, null,
                        React.createElement(DateRangeWrapper, { fetch: this.fetchPopularPerks.bind(this) },
                            React.createElement(TopPerks, { perks: popularPerks }),
                            React.createElement(ExploreMore, { adminPath: "/reporting-v3/redemptions" })))),
                React.createElement(Col, { xs: 12, md: 6 },
                    React.createElement(Card, null,
                        React.createElement(DateRangeWrapper, { fetch: this.fetchActivityData.bind(this) },
                            React.createElement(PlatformActivityChart, { data: activitySeries, dataKeyY: "total", xInterval: 30 })))))));
    };
    return Home;
}(PureComponent));
export default Home;
